module.exports = __webpack_public_path__ + "assets/img/box-6.8bd6c719.jpg";